module.exports = __webpack_public_path__ + "static/media/facefinder.e62afb44.bin";